import PropTypes from 'prop-types';
import React from 'react';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import BlockUi from '../components/waitPanel/BlockUi';
import SupeMoyaService from '../services/SupeMoyaRegistrationService';

class SuperMoyaSettlementConfirmationContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new SupeMoyaService();
        this.state = {
            resultRendered: false,
            resultType: undefined,
            resultMessage: undefined,
        };
        this.validator = new SimpleReactValidator({}, this.translate);
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.service
            .settlementConfirm(this.props.token)
            .then((res) => {
                this.setState({
                    resultType: 'success',
                    resultMessage: 'Dziękujemy,<br />Raport został pozytywnie potwierdzony.',
                    resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                });
                this.unblockUi();
            })
            .catch((err) => {
                if (err?.code === 'SPL_SERVER_ERROR' && err?.params && err?.params['SPL_ERROR_CODE']) {
                    if (
                        err?.params['SPL_ERROR_CODE'] === 'BILLING_ALREADY_ACCEPTED' ||
                        err?.params['SPL_ERROR_CODE'] === 'CUSTOM_BILLING_ALREADY_ACCEPTED'
                    ) {
                        this.setState({
                            resultType: 'success',
                            resultMessage: 'Rozliczenie zostało już wcześniej zaakceptowane.',
                            resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                        });
                    } else if (
                        err?.params['SPL_ERROR_CODE'] === 'BILLING_ALREADY_REJECTED' ||
                        err?.params['SPL_ERROR_CODE'] === 'CUSTOM_BILLING_ALREADY_REJECTED'
                    ) {
                        this.setState({
                            resultType: 'error',
                            resultMessage: 'Rozliczenie zostało już wcześniej odrzucone.',
                            resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                        });
                    } else if (err?.params['SPL_ERROR_CODE'] === 'INVALID_AUTH_CODE') {
                        this.setState({
                            resultType: 'error',
                            resultMessage: 'Błędny Token<br />Coś poszło nie tak.',
                            resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                        });
                    } else {
                        this.setState({
                            resultType: 'error',
                            resultMessage: `${err?.params['SPL_ERROR_MESSAGE']}<br />Coś poszło nie tak.`,
                            resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                        });
                    }
                } else {
                    this.setState({
                        resultType: 'error',
                        resultMessage: `Coś poszło nie tak.`,
                        resultMessageDesc: 'W przypadku pytań prosimy o kontakt z<br />Zespołem Super MOYA',
                    });
                }
                this.unblockUi();
            });
    }

    render() {
        const {resultMessage, resultType, resultMessageDesc} = this.state;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        <div className='app-container'>
                            <div className='title-container'>
                                <img src='/images/super_moya_logo.svg' className='logo' alt='logo moya' />
                            </div>
                            <div className='title-container'>
                                {resultType ? (
                                    <img
                                        src={`/images/${resultType === 'success' ? 'success_ico' : 'error_ico'}.svg`}
                                        className='logo'
                                        alt='result icon'
                                    />
                                ) : null}
                            </div>
                            <div className='row'>
                                <div className='title'>
                                    <label className='text' dangerouslySetInnerHTML={{__html: resultMessage}} />
                                </div>
                            </div>
                            <div className='result-container'>
                                <span className='text' dangerouslySetInnerHTML={{__html: resultMessageDesc}} />
                            </div>
                            <div className='footer-container'>
                                <span className='text'>reklamacje@supermoya.pl</span>
                            </div>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

SuperMoyaSettlementConfirmationContainer.propTypes = {
    token: PropTypes.string,
};

export default SuperMoyaSettlementConfirmationContainer;
